import styled from "styled-components";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/section/footer/Footer";
import MenuSpacer from "../../components/spacer/MenuSpacer";
import JournalsGrid from "./components/JournalsGrid";

const Wrapper = styled.div``;

function JournalsPage() {
  return (
    <Wrapper>
      <Navbar />
      <MenuSpacer />
      <JournalsGrid />
      <Footer />
    </Wrapper>
  );
}

export default JournalsPage;
